export default __webpack_public_path__ + "static/media/10.333baa52.svg";